import { ServicesCustomerDTO } from 'src/modules/servicesCustomer/application/dto/ServicesCustomerDTO'
import { convertToLocalTimeString } from 'src/utils/dateUtils'
import { IUfinetSelectOption } from 'ufinet-web-functions'

import { CorporateIncident } from '../../domain/CorporateIncident'

export class CorporateIncidentsSaveRequest {
	tickets: CorporateIncident[]

	constructor(tickets: CorporateIncident[]) {
		this.tickets = tickets
	}

	static fromValues(
		obj: {
			reportContactId: IUfinetSelectOption
			reportEmail: string
			notificationGroup: IUfinetSelectOption
			reportPhone: string
			creationDate: Date
			notificationLang: IUfinetSelectOption<number>
			affectedService: ServicesCustomerDTO
			internalCustomerTicketNumber: string
			reportType: IUfinetSelectOption<number>
			degradationType: IUfinetSelectOption<number>
			detectionTimestamp: Date
			incidentDescription: string
			visitDate: Date
			visitContact: string
			visitPhone: string
			visitRequirements: string
			countrySelect: IUfinetSelectOption
			corporateGroupSelect: IUfinetSelectOption
			clientSelect: ServicesCustomerDTO
			emailUserApplication: string
		},
		affectedServices: ServicesCustomerDTO[]
	) {
		const tickets: CorporateIncident[] =
			affectedServices.length > 0
				? affectedServices.map((service) => {
						const ticket: CorporateIncident = {
							typeId: 912790000,
							reportOriginId: 3,
							serviceAffectedId: service.value,
							administrativeCode: service.name || undefined,
							customerId: obj.clientSelect.customerId,
							reportTypeId: obj.reportType.value,
							degradationTypeId: obj.degradationType.value || undefined,
							reportContactId: obj.reportContactId.value,
							reportContactEmail: obj.reportEmail,
							reportContactPhone: obj.reportPhone,
							detectedDate: convertToLocalTimeString(obj.detectionTimestamp),
							notificationGroupId: obj.notificationGroup.value || undefined,
							notificationLanguageId: obj.notificationLang.value,
							description: obj.incidentDescription,
							visitingHours: convertToLocalTimeString(obj.visitDate),
							visitContactName: obj.visitContact,
							visitContactPhone: obj.visitPhone,
							visitRequirements: obj.visitRequirements,
							internalCustomerTicketNumber: obj.internalCustomerTicketNumber || undefined,
							emailUserApplication: obj.emailUserApplication,
						}

						return ticket
					})
				: [
						{
							typeId: 912790000,
							reportOriginId: 3,
							serviceAffectedId: obj.affectedService.value,
							administrativeCode: obj.affectedService.name || undefined,
							customerId: obj.clientSelect.customerId,
							reportTypeId: obj.reportType.value,
							degradationTypeId: obj.degradationType.value || undefined,
							reportContactId: obj.reportContactId.value,
							reportContactEmail: obj.reportEmail,
							reportContactPhone: obj.reportPhone,
							detectedDate: convertToLocalTimeString(obj.detectionTimestamp),
							notificationGroupId: obj.notificationGroup.value || undefined,
							notificationLanguageId: obj.notificationLang.value,
							description: obj.incidentDescription,
							visitingHours: convertToLocalTimeString(obj.visitDate),
							visitContactName: obj.visitContact,
							visitContactPhone: obj.visitPhone,
							visitRequirements: obj.visitRequirements,
							internalCustomerTicketNumber: obj.internalCustomerTicketNumber || undefined,
							emailUserApplication: obj.emailUserApplication,
						},
					]

		return new CorporateIncidentsSaveRequest(tickets)
	}
}
